import { Box, Circle, Flex, keyframes, Text } from '@chakra-ui/react'
import { FC } from 'react'

import { HOME_TRUST_STRIP } from '../content'

const movePrimary = keyframes`
  from { left: 0%; }
  to { left: -100%; }
`
const moveSecondary = keyframes`
  from { left: 100%; }
  to { left: 0%; }
`

const Track: FC<{ animation: string; decorative?: boolean }> = ({ animation, decorative = false }) => (
  <Flex
    as="ul"
    aria-hidden={decorative ? 'true' : undefined}
    listStyleType="none"
    m={0}
    w="full"
    animation={animation}
    gap="32px"
    px={4}
    py={{ base: '13px', lg: '25px' }}
    position="absolute"
    top="0%"
    left="0%"
  >
    {HOME_TRUST_STRIP.map((item) => (
      <Flex as="li" key={item} gap={4} alignItems="center" whiteSpace="nowrap">
        <Circle size={2} bg="alabaster" />
        <Text
          color="alabaster"
          fontWeight={800}
          fontSize={{ base: '15px', lg: '20px' }}
          sx={{ fontFeatureSettings: "'ss01' on, 'calt' off, 'liga' off" }}
          letterSpacing={{ base: '-0.6px', lg: '-0.15px' }}
          lineHeight={{ base: '20px', lg: '24px' }}
        >
          {item}
        </Text>
      </Flex>
    ))}
  </Flex>
)

/**
 * Auto-scrolling trust strip of the current landing (`MedleveScrollingBannerSection`), isolated.
 * Differences: items are list items instead of `<h3>` (they are not headings), and the second track —
 * needed only to make the loop seamless — is `aria-hidden`.
 * REQUIRES LEGAL REVIEW — wording in content.ts (`HOME_TRUST_STRIP`).
 */
const HomeTrustStrip: FC = () => (
  <Box bg="alabaster" px="24px" w="full">
    <Box h={{ base: '56px', lg: '80px' }} overflow="hidden" rounded="full" maxWidth="1310px" mx="auto" bg="medleve">
      <Box w={{ base: '1000px', lg: '1350px' }} position="relative">
        <Track animation={`${movePrimary} 12s linear infinite`} />
        <Track animation={`${moveSecondary} 12s linear infinite`} decorative />
      </Box>
    </Box>
  </Box>
)

export default HomeTrustStrip
